const buildExpenseFormData = (values) => {

    const formData = new FormData();

    // مقادیر ثابت
    formData.append("operateId", values.operateId);
    formData.append("operKindId", values.operKindId);
    formData.append("opTitle", values.opTitle);

    // اطلاعات اصلی
    formData.append("carId", values.carId || "");
    formData.append("operDonDate", values.operDonDate || "");
    formData.append("categoryId", values.categoryId || "");

    // اعداد
    formData.append("cost", Number(values.cost) || 0);
    formData.append("operDonKM", Number(values.operDonKM) || 0);

    // متن
    formData.append("description", values.description || "");

    // تصویر فاکتور (اختیاری)
    if (values.imageFile) {

        formData.append("File", values.imageFile, values.imageFile.name);
        formData.append("FileSize", values.imageFile.size);

    }

    return formData;

};

export default buildExpenseFormData;